module.exports = __webpack_public_path__ + "static/media/ai.e5099b26.png";